import type {SlotGameStore, DisplayObject} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";
import {GameDataStore} from "../../../src/GameDataStore";

class GameSymbolView extends SlotGame.src.component.ReelsetComponent.src.SymbolView {
    protected coinsSymbolBG;

    static events = {
        START_REPLACE_MYSTERY_COIN: "GameSymbolView.START_REPLACE_MYSTERY_COIN",
        START_REPLACE_WILD_SYMBOL: "GameSymbolView.START_REPLACE_WILD_SYMBOL",
    }

    public setOverlayView() {
        if (!GameSymbolView.bonusGameConfig.coinSymbolIds.includes(this.id)) return;

        // We change the font when the numbers are many
        const coinBitmapText = game.tree.findByName('coinBitmapText');
        if (coinBitmapText?.options?.text?.length >= 8) {
            coinBitmapText.options.style.fontName = "numbers_coins_small";
            coinBitmapText.options.style.letterSpacing = -3;
            coinBitmapText.updateViewOptions()
        }

        //Use a custom flag to avoid the display bug: delay in showing the bonus
        if ((this.gameData.isBonusGamePopupsInProgress || this.store.gameData.bonusGame.isPlaying()) && !this.coinsSymbolBG) {
            this.coinsSymbolBG = game.builder.create(
                {
                    type: "Sprite",
                    name: "empty_symbols.texture",
                    texture: "empty_symbol",
                    zOrder: 0,
                    //@ts-ignore
                    useParentMask: true
                }
            );

            //this.coinsSymbolBG will always be under everything
            this.addChildAt(this.coinsSymbolBG, 0);
        }

        //After the bonus game, we clean up this.coinsSymbolBG
        if (this.store.gameData.bonusGame.isFinished() && this.coinsSymbolBG) {
            game.utils.PIXIUtils.remove(this.coinsSymbolBG);
            this.coinsSymbolBG = null;
        }

        const textConfigView = GameSymbolView.symbolTextConfig.view;
        this.removeOverlayView();
        this.overlayView = game.builder.create(textConfigView);

        let value = this.store.gameData.reels[this.reelId][this.rowId]?.value;
        let multiplier = this.store.gameData.reels[this.reelId][this.rowId]?.multiplier;

        if (this.rowId < 0) {
            const randomValueIndex = Math.floor(Math.random() * (GameSymbolView.bonusGameConfig.fakeValues.length - 1));
            value = GameSymbolView.bonusGameConfig.fakeValues[randomValueIndex];
        }

        if (!value && !multiplier) return;

        let text;
        if (multiplier) {
            text = `x${multiplier}`;
        } else {
            text = this.store.toFormatMoney(value * this.store.gameData.bet);
        }

        const bitmapText: DisplayObject= game.tree.findByType(BuilderService.types.BitmapText, game.tree.findAll(this.overlayView))![0];
        bitmapText.options.text = text;
        bitmapText.updateViewOptions();

        this.view.addChild(this.overlayView);
        
        switch (String(value)){
            case CONST.JACKPOT.GOLD_MULTIPLIER.toString():     this.setOverlayImage('coin_gold');   return; break;
            case CONST.JACKPOT.SILVER_MULTIPLIER.toString():   this.setOverlayImage('coin_silver'); return; break;
            case CONST.JACKPOT.BRONZE_MULTIPLIER.toString():   this.setOverlayImage('coin_bronze'); return; break;
            case "?" :
                this.setOverlayImage('coin_mystery');
                return; break;
            }

        }
        
    setOverlayImage(name, scale = {x:1, y:1}) {
        this.removeOverlayView();
        this.overlayView = game.builder.create({type: "Sprite", texture: name, scale: scale});

        this.overlayView.updateViewOptions();

        this.view.addChild(this.overlayView);
    }

    async playReplace(){
        if (this.store.gameData.freeSpinsGame.isPlaying() && !this.store.gameData.bonusGame.isPlaying()) {
            game.emit("GameSymbolView.START_REPLACE_WILD_SYMBOL");
        }
        // TODO: remove undefined after fix server
        if(this.id == "undefined" || this.id == CONST.SYMBOLS.COIN){

            const store = (<SlotGameStore>game.store);

            game.emit("GameSymbolView.START_REPLACE_MYSTERY_COIN");

            let value  = store.gameData.reels[this.reelId][this.rowId]?.value;

            await game.utils.GameUtils.playScaleToAnimation(this.overlayView, {scaleFrom: 1, scaleTo: 0, time: 300});

            switch (String(value)){
                case CONST.JACKPOT.GOLD_MULTIPLIER.toString():     this.setOverlayImage('coin_gold', {x:0,y:0});  break;
                case CONST.JACKPOT.SILVER_MULTIPLIER.toString():   this.setOverlayImage('coin_silver', {x:0,y:0}); break;
                case CONST.JACKPOT.BRONZE_MULTIPLIER.toString():   this.setOverlayImage('coin_bronze', {x:0,y:0}); break;
            }
            
            await game.utils.GameUtils.playScaleToAnimation(this.overlayView, {scaleFrom: 0, scaleTo: 1, time: 300});

            return;
        }

        this.playIdle();

        this.removeOverlayView();
        this.overlayView = game.builder.create({
            type: "Graphics",
            parentGroup: "DEBUG",
            backgroundAlpha: 1,
            backgroundColor: 0xffffff,
            width: 270,
            height: 270
        });

        this.overlayView.updateViewOptions();

        this.view.addChild(this.overlayView);

        await game.utils.GameUtils.playAlphaAnimation(this.overlayView, {from: 1, to: 0, time: 500})
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    get gameData(): GameDataStore {
        return (<GameDataStore>this.store.gameData);
    }
}

SlotGame.src.component.ReelsetComponent.src.SymbolView = GameSymbolView;